/** A loopback origin is useful for inspecting development metadata, never for indexing. */
export function localPreviewOrigin(value: string): string {
  try {
    const url = new URL(value);
    return ["http:", "https:"].includes(url.protocol)
      && ["localhost", "127.0.0.1", "[::1]"].includes(url.hostname)
      && !url.username && !url.password && url.pathname === "/" && !url.search && !url.hash
      ? url.origin : "";
  } catch { return ""; }
}
